import { ActionReducerMap } from '@ngrx/store';

import { paginationReducer } from './pagination/pagination.reducer';
import { PaginationState } from './pagination/pagination.state';
import { permissionReducer } from './permission/permission.reducers';
import { PermissionMenusState } from './permission/permission.state';

export interface AppState {
  permission: PermissionMenusState;
  pagination: PaginationState;
}

export const reducers: ActionReducerMap<AppState> = {
  permission: permissionReducer,
  pagination: paginationReducer,
};
